let context;
const notified = new Set();

// Call directly from the initiating gesture, before any async preparation, so
// browsers allow the later completion chime even when another tab is active.
export function prepareCompletionSound() {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    if (!context || context.state === "closed") context = new AudioContext();
    if (context.state === "suspended") context.resume().catch(() => {});
  } catch (_) {
    // Audio is optional; blocked or unavailable audio must never stop a job.
  }
}

export async function playCompletionSound(jobId) {
  if (!context || notified.has(jobId)) return;
  notified.add(jobId);
  try {
    if (context.state === "suspended") await context.resume();
    if (context.state !== "running") return;
    const start = context.currentTime;
    [660, 880].forEach((frequency, index) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      const at = start + index * 0.18;
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, at);
      gain.gain.setValueAtTime(0, at);
      gain.gain.linearRampToValueAtTime(0.12, at + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.001, at + 0.3);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.onended = () => {
        oscillator.disconnect();
        gain.disconnect();
      };
      oscillator.start(at);
      oscillator.stop(at + 0.32);
    });
  } catch (_) {
    // Muted tabs, suspended audio, and device failures do not affect results.
  }
}
